import { IDocument } from '@cyntler/react-doc-viewer';
import { useMemo, useState } from 'react';

/**
 * Hook to handle file preview functionality
 */
export const useFilePreview = () => {
  const [previewingFile, setPreviewingFile] = useState<IDocument | undefined>(
    undefined,
  );

  const previewingDocuments = useMemo(() => {
    return previewingFile ? [previewingFile] : [];
  }, [previewingFile]);

  const closePreview = () => setPreviewingFile(undefined);

  return {
    previewingFile,
    previewingDocuments,
    setPreviewingFile,
    closePreview,
  };
};
